import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { ANALYTICS_ADMISSION_OFFICE, GLOBAL_STATE } from '../constants/actionTypes'

const analyticsSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const analyticsAdmissionOfficeSelector = createSelector(
  analyticsSelectors,
  data => data[ANALYTICS_ADMISSION_OFFICE]
)
